export default __webpack_public_path__ + "static/media/Copy of 09-Check-the-plumbing.4c6a9145.jpg";